export default {
  users: (state) => {
    return state.users;
  },
  user: (state) => {
    return state.user;
  },
  userOptions: (state) => {
    const userOptions = [];
    state.users.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.name,
      };
      userOptions.push(pushItem);
    }
    return userOptions;
  },

  config: (state) => {
    return state.config;
  },

  menus: (state) => {
    return state.menus;
  },
  // Static Getters ---------------------------------------------------------------
  
  roleOptions() {
    return [
      { value: "مدیر کل", text: "مدیر کل" },
      { value: "مدیر داخلی", text: "مدیر داخلی" },
      { value: "ناظر محتوا", text: "ناظر " },
      { value: "پرسنل اداری", text: "پرسنل اداری" },
      { value: "کاربر عادی", text: "کاربر عادی" },
    ];
  },

  testUsers() {
    return [
      {
        id: 1,
        name: "امیر احمدی",
        username: "admin",
        city: "تهران",
        role: "مدیر کل",
        status: 1,
      },
      {
        id: 2,
        name: "سمیرا حسینی",
        username: "samira",
        city: "تهران",
        role: "مدیر داخلی",
        status: 1,
      },
      {
        id: 3,
        name: "ابراهیم رزاقی",
        username: "eRazzaghi",
        city: "تبریز",
        role: "پرسنل اداری",
        status: 1,
      },
      {
        id: 4,
        name: "زهرا معلمی",
        username: "ZMoalemi",
        city: "تهران",
        role: "پرسنل اداری",
        status: 0,
      },
      {
        id: 5,
        name: "فاطمه اخترآبادی",
        username: "akhtarabadi",
        city: "زاهدان",
        role: "کاربر عادی",
        status: 1,
      },
      {
        id: 6,
        name: "حسین ایرانی مفرد",
        username: "hIrani",
        city: "تهران",
        role: "کاربر عادی",
        status: 0,
      },
      {
        id: 7,
        name: "سارینا یزدانی",
        username: "sarina",
        city: "قم",
        role: "کاربر عادی",
        status: 1,
      },
    ];
  },
};
